import { MapUiTheme } from '../../common';

export const toggleTheme = {
  container: {
    display: 'inline-block',
    position: 'relative',
  },
  input: {
    position: 'absolute',
    top: '0',
    left: '0',
    height: '0px',
    width: '0px',
    visibility: 'hidden',

    '&:checked:not(disabled) + .__mapui_toggleLabel': {
      background: (theme: MapUiTheme) => theme.colors.interaction200,
    },
    '&:disabled:not(:checked) + .__mapui_toggleLabel': {
      background: (theme: MapUiTheme) => theme.colors.grey300,
    },
    '&:checked:disabled + .__mapui_toggleLabel': {
      background: (theme: MapUiTheme) => theme.colors.interaction100,
    },
    '&:checked + .__mapui_toggleLabel .__mapui_toggleButton': {
      left: 'calc(100% - 2px)',
      transform: 'translateX(-100%)',
    },
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    width: '44px',
    height: '24px',
    background: (theme: MapUiTheme) => theme.colors.neutral300,
    borderRadius: '100px',
    position: 'relative',
    transition: 'background-color 0.2s',

    '&:active .__mapui_toggleButton': {
      width: '25px',
    },
  },
  labelDisabled: {
    cursor: 'initial',
  },
  button: {
    content: "''",
    position: 'absolute',
    top: '2px',
    left: '2px',
    width: '20px',
    height: '20px',
    borderRadius: '20px',
    transition: '0.2s',
    background: (theme: MapUiTheme) => theme.colors.white,
    boxShadow: '0 0 2px 0 rgba(10, 10, 10, 0.29)',
  },
};
